import { ChildrenProps, ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import styles from "./styles.module.css";

export type CardProps = Partial<ClassNameProps & StyleProps & ChildrenProps>;

export function Card({ className, style, children }: CardProps) {
	return (
		<div className={makeClassName(styles["card"], className)} style={style}>
			{children}
		</div>
	);
}
